import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';

export const StepBettingFootball = ({
                                        userScore,
                                        matchScore,
                                        handleScoreChange,
                                        calculations,
                                        onValidate,
                                        quizPoints = 0,
                                        isDemo = false
                                    }) => {

    const {t} = useTranslation();
    const validateBtnRef = useRef(null);

    const isMinusDisabled = (team) => {
        const currentMatchScore = matchScore?.[team] || 0;
        return userScore[team] <= currentMatchScore;
    };

    const handleScoreClick = (team, type) => {
        handleScoreChange(team, type);
        setTimeout(() => {
            if (validateBtnRef.current) {
                validateBtnRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
            }
        }, 100);
    };

    return (
        <div className="mt-8 animate-fade-in pb-4"> {/* Ajout pb-4 pour marge bas */}

            {/* CARTE PRINCIPALE */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 mb-6">
                <div className="flex justify-center items-center gap-8 mb-6">

                    {/* TEAM 1 */}
                    <div className="flex flex-col items-center gap-2">
                        <button
                            id="demo-btn-plus"
                            onClick={() => handleScoreClick('team1', 'plus')}
                            className="w-11 h-11 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center font-bold text-xl active:scale-90 transition hover:bg-gray-200"
                        >
                            ＋
                        </button>

                        <div className="text-[2.5rem] font-800 text-gray-800 w-16 text-center font-black leading-none">
                            {userScore.team1}
                        </div>

                        <button
                            onClick={() => handleScoreClick('team1', 'minus')}
                            disabled={isMinusDisabled('team1')}
                            className={`w-11 h-11 rounded-full flex items-center justify-center font-bold text-xl transition ${isMinusDisabled('team1') ? 'bg-gray-50 text-gray-300 cursor-not-allowed' : 'bg-gray-100 text-gray-600 active:scale-90 hover:bg-gray-200'}`}
                        >
                            －
                        </button>
                    </div>

                    <div className="h-12 w-px bg-gray-200 mx-2"></div>

                    {/* TEAM 2 */}
                    <div className="flex flex-col items-center gap-2">
                        <button
                            onClick={() => handleScoreClick('team2', 'plus')}
                            className="w-11 h-11 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center font-bold text-xl active:scale-90 transition hover:bg-gray-200"
                        >
                            ＋
                        </button>

                        <div className="text-[2.5rem] font-800 text-gray-800 w-16 text-center font-black leading-none">
                            {userScore.team2}
                        </div>

                        <button
                            onClick={() => handleScoreClick('team2', 'minus')}
                            disabled={isMinusDisabled('team2')}
                            className={`w-11 h-11 rounded-full flex items-center justify-center font-bold text-xl transition ${isMinusDisabled('team2') ? 'bg-gray-50 text-gray-300 cursor-not-allowed' : 'bg-gray-100 text-gray-600 active:scale-90 hover:bg-gray-200'}`}
                        >
                            －
                        </button>
                    </div>
                </div>

                {/* --- ZONE CALCULS / GAINS --- */}
                <div className="pt-4 border-t border-gray-100">
                    {!isDemo && (
                        <>
                            <p className="text-[10px] font-bold text-gray-400 uppercase mb-3 tracking-wider">
                                Composition du Gain Potentiel
                            </p>

                            <div className="space-y-2">
                                {/* Ligne 1 : Bon Vainqueur */}
                                <div
                                    className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded-lg p-2 border-l-4 border-l-win-blue">
                                    <div className="flex items-center gap-2">
                    <span className="text-lg">
                        {userScore.team1 === userScore.team2 ? '🤝' : '🏆'}
                    </span>
                                        <span className="text-[0.75rem] font-bold text-slate-500 uppercase">
                        {userScore.team1 === userScore.team2 ? t('betting.gain_draw') : t('betting.gain_win')}
                    </span>
                                    </div>
                                    <div className="flex items-center gap-2">
                    <span className="bg-blue-100 text-blue-800 text-[10px] font-black px-1.5 py-0.5 rounded">
                        x{calculations.oddsWin}
                    </span>
                                        <span className="font-black text-win-blue text-sm">
                        +{calculations.win}
                    </span>
                                    </div>
                                </div>

                                {/* Ligne 2 : Score Exact */}
                                <div
                                    className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded-lg p-2 border-l-4 border-l-exact-gold">
                                    <div className="flex items-center gap-2">
                                        <span className="text-lg">🎯</span>
                                        <span className="text-[0.75rem] font-bold text-slate-500 uppercase">
                        {t('betting.gain_exact')}
                    </span>
                                    </div>
                                    <div className="flex items-center gap-2">
                    <span className="bg-amber-100 text-amber-800 text-[10px] font-black px-1.5 py-0.5 rounded">
                        x{calculations.oddsScore}
                    </span>
                                        <span className="font-black text-exact-gold text-sm">
                        +{calculations.score}
                    </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    <div className="flex justify-between items-end mt-4 pt-2">
                        <span className="text-xs font-bold text-gray-500">
                             {t('betting.gain_total')}
                        </span>
                        <span className="text-3xl font-black text-brand-dark leading-none">
                            {calculations.total}
                        </span>
                    </div>

                    {quizPoints > 0 && (
                        <div className="mt-3 flex items-center justify-between bg-action-green/5 border border-action-green/15 rounded-lg p-2.5">
                            <span className="text-xs font-bold text-action-green uppercase flex items-center gap-1">
                                <span>⚡</span> {t('betting.quiz_bonus', 'Bonus quiz acquis')}
                            </span>
                            <span className="text-sm font-black text-action-green">+{quizPoints.toLocaleString()} {t('common.points')}</span>
                        </div>
                    )}
                </div>
            </div>

            <button
                id="demo-btn-validate"
                ref={validateBtnRef}
                onClick={onValidate}
                className="w-full py-4 bg-action-green text-white font-bold rounded-xl text-lg shadow-lg hover:brightness-110 active:scale-98 transition-transform"
            >
                {t('betting.validate_btn')}
            </button>
        </div>
    );
};